/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'AdminQueries',
      endpoint:
        'https://g9uu73th04.execute-api.ap-southeast-1.amazonaws.com/vpmetrop',
      region: 'ap-southeast-1',
    },
    {
      name: 'records',
      endpoint:
        'https://svj5erw267.execute-api.ap-southeast-1.amazonaws.com/vpmetrop',
      region: 'ap-southeast-1',
    },
  ],
  aws_appsync_graphqlEndpoint:
    'https://7by7xv73nnfk5ndeu6lj32wyhy.appsync-api.ap-southeast-1.amazonaws.com/graphql',
  aws_appsync_region: 'ap-southeast-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-a5ceabqfbjczrbuhkgrb2dym3i',
  aws_cognito_identity_pool_id:
    'ap-southeast-1:0b52fd9d-fc95-454a-9b1b-663b2dc99d58',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_TFE3l98hl',
  aws_user_pools_web_client_id: '4ngeqja9k12s61f01mc0o22bjb',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default awsmobile;
